import { MeetingPrepCardHide as MeetingPrepCardHideNode, MeetingPrepCardHideReason } from "@acto/gql/graphql";

export default class MeetingPrepCardHide {
  constructor(
    public readonly id: string,
    public readonly clientId: string,
    public readonly prepSessionId: string,
    public readonly cardKey: string,
    public readonly cardType: string,
    public readonly reason: MeetingPrepCardHideReason,
  ) {}

  static fromGraphql(
    data: Pick<MeetingPrepCardHideNode, "id" | "clientId" | "prepSessionId" | "cardKey" | "cardType" | "reason">,
  ): MeetingPrepCardHide {
    return new MeetingPrepCardHide(
      data.id,
      data.clientId,
      data.prepSessionId,
      data.cardKey,
      data.cardType,
      data.reason,
    );
  }
}
